export default "__VITE_ASSET__g1HtAEYp__"